import { __decorate, __metadata, __param } from "tslib";
import { format } from '@/@core/utils/string';
import { inject, injectable } from 'inversify';
import { Symbols } from '../../symbols';
let CompanyXiaoshouyiApi = class CompanyXiaoshouyiApi {
    constructor(http, urls) {
        this.http = http;
        this.urls = urls;
        this.syncById = (company_id) => {
            const url = format(this.urls.postSyncById, {
                company_id,
            });
            return this.http.post({ url });
        };
    }
    getgetXiaoshouyiId(companyName) {
        const url = format(this.urls.getXiaoshouyiId, {
            companyName,
        });
        return this.http.get(url);
    }
};
CompanyXiaoshouyiApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.BoHttp)),
    __param(1, inject(Symbols.CompanyXiaoshouyiApiUrls)),
    __metadata("design:paramtypes", [Object, Object])
], CompanyXiaoshouyiApi);
export { CompanyXiaoshouyiApi };
